import React from 'react';
interface HighlightCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}
export function HighlightCard({
  title,
  description,
  icon
}: HighlightCardProps) {
  return <div className="bg-white rounded-lg shadow-sm p-6 transition-all hover:shadow-md" data-id="element-58">
      <div className="w-12 h-12 bg-sage-light rounded-full flex items-center justify-center mb-4 text-sage-dark" data-id="element-59">
        {icon}
      </div>
      <h3 className="text-lg font-display font-semibold text-navy-dark mb-2" data-id="element-60">
        {title}
      </h3>
      <p className="text-navy text-sm" data-id="element-61">{description}</p>
    </div>;
}